import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { Grid } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import styles from 'modules/Services/NetworksList/services-list.module.scss'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'
import React from 'react'

const LinkComponent = ({ type, children }) => {
  const pathGen = useGeneratePathI18n()

  return (
    <Grid
      gap={40}
      as={Link}
      direction={'column'}
      alignItems={'start'}
      justifyContent={'between'}
      className={clsx(styles['list__item'], styles['list__item_unlinked'])}
      to={pathGen(ROUTES.SERVICES_NETWORK, {
        networkType: type,
      })}
    >
      {children}
    </Grid>
  )
}

LinkComponent.propTypes = {
  type: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.element),
}

export default LinkComponent
